import { render } from "./TheDanToc.vue?vue&type=template&id=ad7efcc4"
import script from "./TheDanToc.vue?vue&type=script&lang=js"
export * from "./TheDanToc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__